import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface CTASectionProps {
    onOpenDemo: (title?: string) => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onOpenDemo }) => {
    return (
        <section className="py-40 px-6 bg-background relative overflow-hidden">
            {/* Dynamic Background Glows */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-primary/10 rounded-full blur-[140px] -z-10 animate-pulse" />

            <div className="max-w-5xl mx-auto text-center space-y-10 relative">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="space-y-6"
                >
                    <h2 className="text-5xl md:text-8xl font-black text-white tracking-tighter leading-[0.9]">
                        Sua cozinha, <br />
                        <span className="text-primary truncate">seu ritmo.</span>
                    </h2>
                    <p className="text-2xl text-secondary max-w-2xl mx-auto font-medium">
                        Junte-se a centenas de restaurantes que transformaram sua gestão com o Garçom Digital.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="flex flex-col sm:flex-row items-center justify-center gap-6"
                >
                    <button 
                        onClick={() => window.location.href = '/admin/login'}
                        className="group px-12 py-6 rounded-full bg-primary text-white font-black text-2xl hover:bg-primary-hover transition-all active:scale-95 shadow-2xl shadow-primary/30 flex items-center gap-3"
                    >
                        Começar Grátis
                        <ArrowRight className="w-8 h-8 group-hover:translate-x-2 transition-transform" />
                    </button>
                    <button 
                        onClick={() => onOpenDemo()}
                        className="px-12 py-6 rounded-full bg-white/5 border border-white/10 text-white font-bold text-2xl hover:bg-white/10 transition-all active:scale-95"
                    >
                        Agendar Demo
                    </button>
                </motion.div>

                <p className="text-secondary/50 font-bold uppercase tracking-[0.3em] text-[10px]">
                    7 dias grátis. Não requer cartão de crédito.
                </p>
            </div>
        </section>
    );
};

export default CTASection;
